const windowsReqs = [
  { label: 'Operating System', value: 'Windows 7 or later (64-bit)' },
  { label: 'Processor', value: '1 GHz Intel processor or greater' },
  { label: 'RAM', value: '2 GB RAM (4 GB recommended)' },
  { label: 'Hard Disk Space', value: '1 GB free hard disk space' },
  { label: 'Display', value: '1024 x 768 resolution or higher' },
  { label: 'Internet Connection', value: 'Required for activation and updates' },
];

const macReqs = [
  { label: 'Operating System', value: 'macOS 10.13 or later' },
  { label: 'Processor', value: 'Intel Core 2 Duo or greater' },
  { label: 'RAM', value: '2 GB RAM (4 GB recommended)' },
  { label: 'Hard Disk Space', value: '1 GB free hard disk space' },
  { label: 'Display', value: '1024 x 768 resolution or higher' },
  { label: 'Internet Connection', value: 'Required for activation and updates' },
];

function ReqColumn({ title, items }) {
  return (
    <div className="bg-white/[0.07] border border-white/15 p-5 sm:p-7 md:p-8">
      <h3 className="font-serif text-xl sm:text-2xl text-white mb-5 sm:mb-6 pb-3 sm:pb-4 border-b border-white/20">{title}</h3>
      <dl className="space-y-4 sm:space-y-5">
        {items.map((item) => (
          <div key={item.label}>
            <dt className="text-[11px] sm:text-xs font-bold uppercase tracking-[0.14em] text-[#bbf7d0] mb-1">
              {item.label}
            </dt>
            <dd className="text-white/90 text-sm sm:text-base m-0">{item.value}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}

export default function SystemRequirements() {
  return (
    <section className="t7-section t7-section--forest">
      <div className="container">
        <div className="t7-head t7-head--center">
          <p className="t7-kicker">Compatibility</p>
          <h2 className="t7-title t7-title--center">System requirements</h2>
          <p className="t7-lead t7-lead--center">
            Check that your Windows or Mac machine meets these baselines before installing.
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto">
          <ReqColumn title="Windows" items={windowsReqs} />
          <ReqColumn title="macOS" items={macReqs} />
        </div>
      </div>
    </section>
  );
}
